/**
 * L'écran d'une adresse qui ne correspond à aucun module.
 *
 * Il nomme la cause probable et donne le chemin de retour. Une page « 404 »
 * muette laisserait un opérateur bloqué sur une adresse qu'il a peut-être
 * reçue par courriel.
 */

import type { ReactNode } from 'react';

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { homeModulePath } from './routes.js';

/** L'écran d'erreur de route. */
export function RouteErrorScreen(): ReactNode {
  const { t } = useTranslation();
  return (
    <section className="route-error" aria-labelledby="route-error-heading">
      <h2 className="route-error__heading" id="route-error-heading">
        {t('routeError.heading')}
      </h2>
      <p className="route-error__body">{t('routeError.body')}</p>
      <Link className="route-error__action" to={homeModulePath}>
        {t('routeError.action')}
      </Link>
    </section>
  );
}
